<template>
    <footer class="px-3 py-4 lg:p-12 bg-black relative text-white">
        <AtomFluxLogo color="white" class="absolute" />

        <div class="flex flex-col gap-4 lg:flex-row-reverse lg:gap-20">
            <div class="flex justify-end">
                <ul>
                    <li><a target="_blank" href="https://www.instagram.com/flux_laboratory">Instagram</a></li>
                    <li><a target="_blank" href="https://www.facebook.com/fluxlaboratory">Facebook</a></li>
                    <li><a target="_blank" href="https://vimeo.com/user115770217">Vimeo</a></li>
                    <li><a target="_blank" href="https://soundcloud.com/fluxlab">Soundcloud</a></li>
                    <!-- <li><a target="_blank" href="https://www.youtube.com/user/FLUXLaboratory">Youtube</a></li> -->
                    <li><a target="_blank" href="https://airtable.com/appjplymbVAKYrAgb/shrE7FNivxdnUJBNs">Newsletter</a></li>
                </ul>
            </div>

            <div class="order-1">
                <p>
                    Fondation Fluxum <br>
                    Flux Laboratory <br>
                    Rue de Chantepoulet 1-3<br>
                    CH - 1201 Genève<br>
                    <br>
                    +41 22 436 81 91 <br>
                    <a target="_blank" href="mailto:info@fluxumfoundation.org">info@fluxumfoundation.org</a> <br>
                    <br>
                    +41 22 308 14 50 <br>
                    <a target="_blank" href="mailto:agenda@fluxlaboratory.com">agenda@fluxlaboratory.com</a>
                </p>
            </div>

            <div class="mt-4 lg:mt-0">
                <p>
                    Flux Laboratory Athens <br>
                    12 Geronta <br>
                    GR - 10558 Athens <br>
                    <br>
                    +30 210 0108357 <br>
                    <a target="_blank" href="mailto:athens@fluxlaboratory.com">athens@fluxlaboratory.com</a>
                </p>
            </div>
        </div>
    </footer>
</template>

<script>
import AtomFluxLogo from "../atoms/AtomFluxLogo.vue";

export default {
    name: "OrganismFooter",
    components: {AtomFluxLogo},
}
</script>

<style scoped lang="scss">
a:hover {
    text-decoration: underline !important;
}
</style>
